import ItemSliding1 from "../item/src/item.sliding-test.vue";


ItemSliding1.install = function () {
    Vue.component(ItemSliding1.name, ItemSliding1);
};

export default ItemSliding1;


// WEBPACK FOOTER //
// ./src/components/item-sliding/index-test.js